import { Injectable } from '@angular/core';
import TurndownService from 'turndown';

// Implementation comes from the original https://github.com/mixmark-io/turndown/blob/master/src/turndown.js
// Supplemented with '~' character escape
const escapes = [
  [/\\/g, '\\\\'],
  [/\*/g, '\\*'],
  [/\~/g, '\\~'],
  [/^-/g, '\\-'],
  [/^\+ /g, '\\+ '],
  [/^(=+)/g, '\\$1'],
  [/^(#{1,6}) /g, '\\$1 '],
  [/`/g, '\\`'],
  [/^~~~/g, '\\~~~'],
  [/\[/g, '\\['],
  [/\]/g, '\\]'],
  [/^>/g, '\\>'],
  [/_/g, '\\_'],
  [/^(\d+)\. /g, '$1\\. ']
];

TurndownService.prototype.escape = function(content: string) {
  return escapes.reduce(function (accumulator, escape) {
    return accumulator.replace(escape[0], escape[1] as string)
  }, content);
}

@Injectable()
export class Turndown {
  private _turndownService: TurndownService
  private static readonly _escapeCharacterRegex = /(?:\\(.))/g;

  constructor() {
    this._turndownService = new TurndownService();

    const boldRule = {
      filter: 'strong',
      replacement: function(content) {
        return `*${content}*`;
      }
    };

    const strikethroughRule = {
      filter: ['s', 'del'],
      replacement: function(content) {
        return `~${content}~`;
      }
    };

    this._turndownService
      .addRule('bold', boldRule)
      .addRule('strikethrough', strikethroughRule);
      //Italic works out of the box.
  }

  addRule(key: string, rule: any): TurndownService {
    return this._turndownService.addRule(key, rule);
  }

  convert(text: string, removeEscapeCharacter = false): string {
    const markdown: string = this._turndownService.turndown(text);
    return removeEscapeCharacter ? markdown.replace(Turndown._escapeCharacterRegex, '$1') : markdown;
  }

}
